import { axiosStudentInstance } from "./studentAuth"
import type { StudentApiEnvelope } from "./studentQuestions"
import type {
  PaperSession,
  PaperTemplate,
} from "../page/Student/PracticePapers/types"

export interface PracticePaperGeneratePayload {
  subject_id?: string
  hierarchy_ids?: string[]
  /** @deprecated Prefer hierarchy_ids — kept for older clients */
  topic_ids?: string[]
  count?: number
  template_id?: string
  use_ai?: boolean
  title?: string
  grade?: string
  context_mode?: string
}

export interface PracticePaperPdfResponse {
  pdf_url: string
  expires_in: number
}

export type PracticePaperSession = PaperSession & {
  shortfall?: number
  questionCount?: number
  requestedCount?: number
  totalMarks?: number
}

export type StudentPublishedTemplate = PaperTemplate & {
  id: string
  subjectId: string
  grade?: string | null
}

export const listPracticePapers = (
  page = 1,
  limit = 50,
  subjectId?: string
) =>
  axiosStudentInstance.get<StudentApiEnvelope<PracticePaperSession[]>>(
    "/practice-papers/",
    {
      params: {
        page,
        limit,
        ...(subjectId ? { subject: subjectId } : {}),
      },
    }
  )

export const getPracticePaper = (paperId: string) =>
  axiosStudentInstance.get<StudentApiEnvelope<PracticePaperSession>>(
    `/practice-papers/${paperId}/`
  )

export const generatePracticePaper = (payload: PracticePaperGeneratePayload) =>
  axiosStudentInstance.post<StudentApiEnvelope<PracticePaperSession>>(
    "/practice-papers/generate/",
    payload
  )

export const deletePracticePaper = (paperId: string) =>
  axiosStudentInstance.delete<StudentApiEnvelope<{ id: string }>>(
    `/practice-papers/${paperId}/`
  )

export const getPracticePaperPdf = (paperId: string) =>
  axiosStudentInstance.get<StudentApiEnvelope<PracticePaperPdfResponse>>(
    `/practice-papers/${paperId}/pdf/`
  )

export const listPublishedTemplates = (page = 1, limit = 5, subjectId?: string) =>
  axiosStudentInstance.get<StudentApiEnvelope<StudentPublishedTemplate[]>>(
    "/templates/",
    {
      params: {
        page,
        limit,
        ...(subjectId ? { subject: subjectId } : {}),
      },
    }
  )
